import { defineStore } from "pinia";
import { login, switchLogin } from "@/api/api";
import { ConfigEnum } from "@/enums/httpEnum";
import { UserInfo } from "@/model/login";

export const useStore = defineStore("storeId", {
  state: () => {
    return {
      // 教育局ID
      tenantId: "",
      // token
      token: "",
      // 用户信息
      userInfo: null,
      configData: null,
      izPrinter: false,
      // 学校配置信息 (queryBySchoolId返回的数据)
      schoolConfig: null,
      // 扫码收货配置：{ scanReceiving, autoReceiving, autoReceivingWeight, receiveMode }
      // receiveMode: 导航栏收货模式开关，a=自动收货 b=手动收货，供 sortingWeighing 页使用
      scanReceivingConfig: null,
    };
  },
  getters: {
    getTenantId: (state) => {
      // @ts-ignore
      return state.tenantId || localStorage.getItem(ConfigEnum.TENANT_ID);
    },
    getToken: (state) => {
      // @ts-ignore
      return state.token || localStorage.getItem(ConfigEnum.TOKEN);
    },
    getUserInfo: (state) => {
      // @ts-ignore
      return state.userInfo || localStorage.getItem(ConfigEnum.USER_INFO);
    },
    getConfigData: (state) => {
      // @ts-ignore
      return state.configData || localStorage.getItem(ConfigEnum.CONFIG);
    },
    getIzPrinterData: (state) => {
      // @ts-ignore
      return state.izPrinter || localStorage.getItem(ConfigEnum.IZ_PRINTER);
    },
    getSchoolConfig: (state) => {
      // @ts-ignore
      return state.schoolConfig || localStorage.getItem(ConfigEnum.SCHOOL_CONFIG);
    },
    getScanReceivingConfig: (state) => {
      // @ts-ignore
      return (
        state.scanReceivingConfig ||
        localStorage.getItem(ConfigEnum.SCAN_RECEIVING_CONFIG)
      );
    },
  },
  actions: {
    setTenantId(value: string) {
      this.tenantId = value;
      localStorage.setItem(ConfigEnum.TENANT_ID, value);
    },
    setToken(value: string) {
      this.token = value;
      localStorage.setItem(ConfigEnum.TOKEN, value);
    },
    setUserInfo(value: UserInfo) {
      // @ts-ignore
      this.userInfo = value;
      localStorage.setItem(ConfigEnum.USER_INFO, JSON.stringify(value));
    },
    removeCache() {
      localStorage.clear();
    },
    login(values: object) {
      return new Promise((resolve, reject) => {
        login(values)
          .then((res) => {
            if (res.success) {
              this.setToken(res.result.token);
              this.setTenantId(res.result.userInfo?.relTenantIds);
              this.setUserInfo(res.result.userInfo);
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    switchLogin(values: object) {
      return new Promise((resolve, reject) => {
        switchLogin(values)
          .then((res) => {
            if (res.success) {
              this.setToken(res.result.token);
              this.setTenantId(res.result.userInfo?.relTenantIds);
              this.setUserInfo(res.result.userInfo);
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    loginOut() {
      return new Promise((resolve, reject) => {
        this.removeCache();

        resolve(true);
      });
    },
    setConfigData(value: any) {
      this.configData = value;
      localStorage.setItem(ConfigEnum.CONFIG, value);
    },
    setIzPrinterData(value: any) {
      this.izPrinter = value;
      localStorage.setItem(ConfigEnum.IZ_PRINTER, value);
    },
    setSchoolConfig(value: any) {
      this.schoolConfig = value;
      localStorage.setItem(ConfigEnum.SCHOOL_CONFIG, JSON.stringify(value));
    },
    setScanReceivingConfig(value: any) {
      this.scanReceivingConfig = value;
      localStorage.setItem(ConfigEnum.SCAN_RECEIVING_CONFIG, JSON.stringify(value));
    },
  },
});
